import Vue from 'vue'
import XRdrawer  from './drawer'

export default XRdrawer




// WEBPACK FOOTER //
// ./src/components/drawer/index.js